module.exports = __webpack_public_path__ + "media/images/flags/64/Somaliland-a216432192c8d69e22a300799fe9ba6c.png";